import axios from 'axios';
import { storage } from '../utils/storage';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:9090',
  headers: { 'Content-Type': 'application/json' }
});

// Request interceptor - add token to every request
api.interceptors.request.use(
  (config) => {
    const token = storage.getToken();
    if (token) {
      // Check if token is expired before sending
      if (storage.isTokenExpired()) {
        console.log('Token expired before request');
        storage.clear();
        window.location.href = '/login?session=expired';
        return Promise.reject(new Error('Token expired'));
      }
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - handle 401 Unauthorized responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.log('Token expired or invalid - logging out');
      storage.clear();
      window.location.href = '/login?session=expired';
    }
    return Promise.reject(error);
  }
);

export default api;